import AwbQuery from "./components/AwbQuery/AwbQuery";
import { CommingSoon } from "./components/CommonComponents/ComingSoon";
import Dashboard from "./components/Dashboard/Dashboard";
import ImportPacketBooking from "./components/Import/ImportPacketBooking";
import ImportPickUpRequest from "./components/Import/ImportPickUpRequest";
import ImportProgressUpdate from "./components/Import/ImportProgressUpdate";
import BranchMaster from "./components/Master/BranchMaster";
import CityMaster from "./components/Master/CityMaster";
import ClientMaster from "./components/Master/ClientMaster";
import CompanyMaster from "./components/Master/CompanyMaster";
import CountryMaster from "./components/Master/CountryMaster";
import LanguageMaster from "./components/Master/LanguageMaster";
import PinCodeMaster from "./components/Master/PinCodeMaster";
import StateMaster from "./components/Master/StateMaster";
import VendorMaster from "./components/Master/VendorMaster";
import ZoneMaster from "./components/Master/ZoneMaster";
import AssignPickupRequest from "./components/Operation/AssignPickupRequest";
import CancelPickup from "./components/Operation/CancelPickup";
import DispatchEntry from "./components/Operation/DispatchEntry";
import InScanAtWarehouse from "./components/Operation/InScanAtWarehouse";
import ManifestEntry from "./components/Operation/ManifestEntry";
import PacketBooking from "./components/Operation/PacketBooking";
import PickUpRequest from "./components/Operation/PickUpRequest";
import ProgressUpdate from "./components/Operation/ProgressUpdate";
import UnBagging from "./components/Operation/UnBagging";
import UnDispatch from "./components/Operation/UnDispatch";
import DispatchReport from "./components/Report/DispatchReport";
import ManifestReport from "./components/Report/ManifestReport";
import PacketBookingReport from "./components/Report/PacketBookingReport";
import PickUpReport from "./components/Report/PickUpReport";
import PickupRunsheetReport from "./components/Report/PickupRunsheetReport";
import UpdatePacketBooking from "./components/Update/UpdatePacketBooking";
import UpdatePickUpRequest from "./components/Update/UpdatePickUpRequest";
import ChangePassword from "./components/UserSection/ChangePassword";
import GroupMasterForm from "./components/UserSection/GroupMaster";
import GroupMenuAccess from "./components/UserSection/GroupMenuAccess";
import ResetPassword from "./components/UserSection/ResetPassword";
import UserMaster from "./components/UserSection/UserMaster";

export const routes = [
    {
        path: '*',
        component: CommingSoon
    },
    {
        path: 'Dashboard',
        component: Dashboard
    },
    {
        path: 'UserMaster',
        component: UserMaster
    },
    {
        path: 'ChangePassword',
        component: ChangePassword
    },
    {
        path: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: 'GroupMaster',
        component: GroupMasterForm
    },
    {
        path: 'GroupMenuAccess',
        component: GroupMenuAccess
    },
    {
        path: 'CityMaster',
        component: CityMaster
    },
    {
        path: 'CountryMaster',
        component: CountryMaster
    },
    {
        path: 'StateMaster',
        component: StateMaster
    },
    {
        path: 'PinCodeMaster',
        component: PinCodeMaster
    },
    {
        path: 'CompanyMaster',
        component: CompanyMaster
    },
    {
        path: 'BranchMaster',
        component: BranchMaster
    },
    {
        path: 'ClientMaster',
        component: ClientMaster
    },
    {
        path: 'LanguageMaster',
        component: LanguageMaster
    },
    {
        path: 'PickUpRequest',
        component: PickUpRequest
    },
    {
        path: 'PickUpReport',
        component: PickUpReport
    },
    {
        path: 'ZoneMaster',
        component: ZoneMaster
    },
    {
        path: 'CancelPickup',
        component: CancelPickup
    },
    {
        path: 'InScanAtWarehouse',
        component: InScanAtWarehouse
    },
    {
        path: 'AssignPickupRequest',
        component: AssignPickupRequest
    },
    {
        path: 'PacketBooking',
        component: PacketBooking
    },
    {
        path: 'UpdatePickUpRequest',
        component: UpdatePickUpRequest
    },
    {
        path: 'UpdatePacketBooking',
        component: UpdatePacketBooking
    },
    {
        path: 'ManifestEntry',
        component: ManifestEntry
    },
    {
        path: 'VendorMaster',
        component: VendorMaster
    },
    {
        path: 'UnBagging',
        component: UnBagging
    },
    {
        path: 'BookingReport',
        component: PacketBookingReport
    },
    {
        path: 'DispatchReport',
        component: DispatchReport
    },
    {
        path: 'Dispatch',
        component: DispatchEntry
    },
    {
        path: 'UnDispatch',
        component: UnDispatch
    },
    {
        path: 'ManifestReport',
        component: ManifestReport
    },
    {
        path: 'AwbQuery',
        component: AwbQuery
    },
    {
        path: 'PickupRunsheetReport',
        component: PickupRunsheetReport
    },
    {
        path: 'ImportPickUpRequest',
        component: ImportPickUpRequest
    },
    {
        path: 'ProgressUpdate',
        component: ProgressUpdate
    },
    {
        path: 'ImportProgressUpdate',
        component: ImportProgressUpdate
    },
    {
        path: 'ImportPacketBooking',
        component: ImportPacketBooking
    },
]
